import { axiosInstance } from "./axios";
import { ListType } from "dto/ListType";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { IFilter } from "dto/IFilter";

const queryKeys = {
  getFilter: (id: string) => ["filterService.getFilter", id],
  getStaticFilter: (id: string) => ["filterService.getStaticFilter", id],
  getFiltersForCategory: (id: number) => [
    "filterService.getFiltersForCategory",
    id,
  ],
};

const getFilter = (id?: string): Promise<{ data: IFilter }> => {
  if (!id) {
    return null;
  }

  return axiosInstance.get(`/list/filter?id=${id}`);
};

const useGetFilter = (id?: string, enabled: boolean = true) => {
  return useCustomQuery(queryKeys.getFilter(id), () => getFilter(id), {
    enabled: enabled,
  });
};

const getStaticFilter = (id?: string): Promise<{ data: IFilter }> => {
  if (!id) {
    return null;
  }

  return axiosInstance.get(`/list/static/filter?id=${id}`);
};

const useGetStaticFilter = (id?: string, enabled: boolean = true) => {
  return useCustomQuery(
    queryKeys.getStaticFilter(id),
    () => getStaticFilter(id),
    {
      enabled: enabled,
    }
  );
};

const getFiltersForCategory = ({ id }: { id: number | string | ListType }) => {
  return axiosInstance.get(`/list/filters?list=${id}`);
};

const useGetFiltersForCategory = () => {
  return useCustomMutation(getFiltersForCategory);
};

const createFilterForCategory = (payload: any) => {
  return axiosInstance.post("/List/Filter", payload);
};

const useCreateFilterForCategory = () => {
  return useCustomMutation(createFilterForCategory);
};

const deleteFilterForCategory = (payload: { Id: string }) => {
  return axiosInstance.delete("/list/filter", { data: payload });
};

const useDeleteFilterForCategory = () => {
  return useCustomMutation(deleteFilterForCategory);
};

export default {
  useGetFiltersForCategory,
  useCreateFilterForCategory,
  useDeleteFilterForCategory,
  useGetFilter,
  useGetStaticFilter,
};
